import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconMails",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.5 2.5A.5.5 0 0 0 4 3v.2l3.283 1.748a.458.458 0 0 0 .433 0L11 3.2V3a.5.5 0 0 0-.5-.5h-6Zm7.5.99V3a1.5 1.5 0 0 0-1.5-1.5h-6A1.5 1.5 0 0 0 3 3v4.5A1.5 1.5 0 0 0 4.5 9h6A1.5 1.5 0 0 0 12 7.5V3.49Zm-1 .843-2.817 1.5a1.46 1.46 0 0 1-1.366 0l-.002-.002L4 4.333V7.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V4.333ZM1.5 3.5A.5.5 0 0 1 2 4v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1h-7C1.674 11 1 10.326 1 9.5V4a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function h(e, u, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--mails"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Mails",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, m, 10, c);
}
const A = /* @__PURE__ */ n(o, [["render", h]]);
export {
  A as default
};
//# sourceMappingURL=mails.js.map
